/**
 * Canonical screen transition — v237.15.0
 *
 * "Each screen opens from top down until a hard stop."
 *
 * The incoming screen enters from just above its resting position, settles
 * downward, and arrests with a decisive ease-out — no overshoot, no bounce
 * (the "hard stop"). Exit is a quick downward drift + fade so the flow always
 * reads top → down.
 *
 * Single source of truth: PageWrapper (App.jsx) and OnboardingFlow both import
 * from here, so the motion can never drift between surfaces again.
 *
 * Tuned values (approved): drop 36px · in 240ms decelerate · out 140ms.
 */

// Decelerate to a hard stop — holds velocity, then arrests. No overshoot.
export const SCREEN_EASE_IN = [0.12, 0.8, 0.16, 1]
// Accelerate away — standard ease-in for departures.
export const SCREEN_EASE_OUT = [0.4, 0.0, 1, 1]

export const SCREEN_DROP_PX = 36
export const SCREEN_IN_SEC = 0.24
export const SCREEN_OUT_SEC = 0.14

// Top-down drop → hard stop. Canonical for every screen.
export const screenVariants = {
  initial: { opacity: 0, y: -SCREEN_DROP_PX },
  animate: { opacity: 1, y: 0, transition: { duration: SCREEN_IN_SEC, ease: SCREEN_EASE_IN } },
  exit: { opacity: 0, y: 10, transition: { duration: SCREEN_OUT_SEC, ease: SCREEN_EASE_OUT } },
}

// Lateral peers (tab ↔ tab): a plain fade — a sideways move shouldn't read as "opening".
export const fadeVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.16, ease: 'easeOut' } },
  exit: { opacity: 0, transition: { duration: 0.12, ease: 'easeIn' } },
}

// Reduced-motion: opacity only, no transform.
export const reducedVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.12 } },
  exit: { opacity: 0, transition: { duration: 0.08 } },
}
